(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
document.addEventListener('cart:change', () => {
  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ibey-home-intro"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ibey-benefits')) {
  customElements.define('ibey-benefits', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ibey-home-intro__benefits');
      this.items = [...this.track.children];
      this.reduced = matchMedia('(prefers-reduced-motion:reduce)');
      this.controller = new AbortController();
      const opts = {signal:this.controller.signal};
      this.addEventListener('mouseenter',()=>{this.hovered=true},opts);
      this.addEventListener('mouseleave',()=>{this.hovered=false},opts);
      this.track.addEventListener('pointerdown',()=>{this.interacted=Date.now()},opts);
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting});
      this.observer.observe(this);
      this.timer=setInterval(()=>{
        if(matchMedia("(min-width:700px)").matches||this.reduced.matches||this.hovered||!this.visible||document.hidden||Date.now()-(this.interacted||0)<10000)return;
        const index=Math.round(this.track.scrollLeft/this.track.clientWidth);
        this.track.scrollTo({left:((index+1)%this.items.length)*this.track.clientWidth,behavior:'smooth'});
      },5000);
    }
    disconnectedCallback(){clearInterval(this.timer);this.controller?.abort();this.observer?.disconnect()}
  });
}

  } catch(e) { console.error(e); }
})();
})();
